import React from 'react'
import Layout from 'components/Layout'

import { headerThemeContext } from 'components/Header/Pc'
import { Navigatable } from 'components/Navigator'
import PageBanner from 'components/PageBanner'

import ApplyForm from 'components/pages/cooperations/ApplyForm'

import pcBanner from 'components/pages/cooperations/images/pcBanner.png'
import mobileBanner from 'components/pages/cooperations/images/mobileBanner.png'
import Advantage from 'components/pages/cooperations/Advantage'

function PageContent() {
  return (
    <Navigatable>
      <PageBanner
        title="大客户合作通道"
        desc="汇聚边缘力量，共创美好未来"
        pcImg={pcBanner}
        mobileImg={mobileBanner}
        backgroundColor="#A98FFA"
        pcHeight={400}
        href={null}
        dark
        btns={[{ href: '/cooperations#apply', type: 'primary', children: '立即申请' }]}
      />

      <Advantage />
      <ApplyForm />
    </Navigatable>
  )
}

export default function CooperationsPage() {
  return (
    <headerThemeContext.Provider value="default" >
      <Layout
        title="商务合作"
        keywords="合作, 节点招募"
        description="NiuLink 简单高效的雾计算平台"
      >
        <PageContent />
      </Layout>
    </headerThemeContext.Provider>
  )
}
